import { render, staticRenderFns } from "./QuotesListResume.vue?vue&type=template&id=456554f6&scoped=true&"
import script from "./QuotesListResume.vue?vue&type=script&lang=js&"
export * from "./QuotesListResume.vue?vue&type=script&lang=js&"
import style0 from "./QuotesListResume.vue?vue&type=style&index=0&id=456554f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456554f6",
  null
  
)

export default component.exports